import React, { useState } from "react";
import { ShoppingBag } from "lucide-react";
import MerchItemsAdmin from "@/components/merch/MerchItemsAdmin";
import MerchOrdersAdmin from "@/components/merch/MerchOrdersAdmin";

const VIEWS = [["items", "Items"], ["orders", "Orders"]];

export default function MerchAdmin() {
  const [view, setView] = useState("items");
  return (
    <div data-testid="merch-admin-tab">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
        <div>
          <div className="label-eyebrow text-[var(--ff-red)] mb-2 flex items-center gap-2"><ShoppingBag size={12} /> ▮ MERCH STORE</div>
          <h2 className="font-display text-3xl">{view === "items" ? "Per-Show Merch" : "Orders & Fulfillment"}</h2>
        </div>
        <div className="flex gap-px bg-[var(--ff-border)]">
          {VIEWS.map(([k, label]) => (
            <button key={k} onClick={() => setView(k)} data-testid={`merch-view-${k}`}
              className={`px-5 py-2.5 font-mono-ui text-xs uppercase tracking-[0.18em] transition-colors ${view === k ? "bg-[var(--ff-red)] text-white" : "bg-[var(--ff-surface)] text-[var(--ff-text-dim)] hover:text-white"}`}>
              {label}
            </button>
          ))}
        </div>
      </div>
      {view === "items" ? <MerchItemsAdmin /> : <MerchOrdersAdmin />}
    </div>
  );
}
